import { useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom'
import axios from 'axios'

export type MeUser = {
  id: number
  organizationId: number | null
  email: string
  name: string | null
  isAdmin: boolean
}

type Props = {
  require?: 'any' | 'customer' | 'admin'
  children: React.ReactNode
}

export default function AuthGate({ require = 'any', children }: Props) {
  const [loading, setLoading] = useState(true)
  const [user, setUser] = useState<MeUser | null>(null)

  useEffect(() => {
    let mounted = true
    axios
      .get('/api/auth/me', { withCredentials: true })
      .then((r) => {
        if (!mounted) return
        setUser(r.data?.user ?? null)
      })
      .catch(() => {
        if (!mounted) return
        setUser(null)
      })
      .finally(() => {
        if (!mounted) return
        setLoading(false)
      })
    return () => {
      mounted = false
    }
  }, [])

  if (loading) {
    return (
      <div className="pt-32 pb-24 min-h-screen">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-slate-200 dark:bg-slate-700 animate-pulse rounded-2xl h-40" />
        </div>
      </div>
    )
  }

  if (!user) return <Navigate to="/login" replace />

  if (require === 'admin' && !user.isAdmin) return <Navigate to="/portal" replace />
  if (require === 'customer' && !user.organizationId) return <Navigate to="/admin" replace />

  return <>{children}</>
}

